export default __webpack_public_path__ + "static/AI-Content-Assistant-7882f80e1874f979507e29f8e0d903fe.mp4";